<template>
  <div class="individual-results" :class="multiColor ? 'multicolor' : ''">
    <div class="individual-results__members">
      <i18n-t keypath="pdfReport.team_member" :locale="lang" tag="div" class="text"></i18n-t>
      <div class="text" v-for="member in data" :key="`${member.firstName}_${member.lastName}`">{{ member.firstName }} {{ member.lastName }}</div>
    </div>

    <div class="individual-results__result result-1">
      <div class="individual-results__result-row head-row">
        <div v-if="multiColor" class="text light"></div>
        <template v-else><i18n-t keypath="pdfReport.decisiveness" :locale="lang" tag="div" class="text light"></i18n-t></template>
      </div>
      <div class="individual-results__result-row head-row">
        <template v-if="multiColor"><i18n-t keypath="pdfReport.preserving_heading" :locale="lang" tag="div" class="text light"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.low" :locale="lang" tag="div" class="text light"></i18n-t></template>

        <template v-if="multiColor"><i18n-t keypath="pdfReport.changing_heading" :locale="lang" tag="div" class="text light"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.high" :locale="lang" tag="div" class="text light"></i18n-t></template>
      </div>
      <div v-for="member in data" :key="`result-1-${member.name}`" class="individual-results__result-row">
        <div :class="isFilled(member, multiColor ? 'Preserving' : 'Decisiveness-low') ? 'filled' : ''"></div>
        <div :class="isFilled(member, multiColor ? 'Changing' : 'Decisiveness-high') ? 'filled' : ''"></div>
      </div>
    </div>

    <div class="individual-results__result result-2">
      <div class="individual-results__result-row head-row">
        <div v-if="multiColor" class="text light"></div>
        <template v-else><i18n-t keypath="pdfReport.socialimpact" :locale="lang" tag="div" class="text light"></i18n-t></template>
      </div>
      <div class="individual-results__result-row head-row">
        <template v-if="multiColor"><i18n-t keypath="pdfReport.independent_heading" :locale="lang" tag="div" class="text light"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.low" :locale="lang" tag="div" class="text light"></i18n-t></template>

        <template v-if="multiColor"><i18n-t keypath="pdfReport.relationoriented_heading2" :locale="lang" tag="div" class="text light visible-overflow"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.high" :locale="lang" tag="div" class="text light visible-overflow"></i18n-t></template>
      </div>
      <div v-for="member in data" :key="`result-2-${member.name}`" class="individual-results__result-row">
        <div :class="isFilled(member, multiColor ? 'Independent' : 'Social-impact-low') ? 'filled' : ''"></div>
        <div :class="isFilled(member, multiColor ? 'Relation-oriented' : 'Social-impact-high') ? 'filled' : ''"></div>
      </div>
    </div>

    <div class="individual-results__result result-3">
      <div class="individual-results__result-row head-row">
        <div v-if="multiColor" class="text light"></div>
        <template v-else><i18n-t keypath="pdfReport.stressmanagement" :locale="lang" tag="div" class="text light"></i18n-t></template>
      </div>
      <div class="individual-results__result-row head-row">
        <template v-if="multiColor"><i18n-t keypath="pdfReport.flexible_heading" :locale="lang" tag="div" class="text light"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.low" :locale="lang" tag="div" class="text light"></i18n-t></template>

        <template v-if="multiColor"><i18n-t keypath="pdfReport.structured_heading" :locale="lang" tag="div" class="text light"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.high" :locale="lang" tag="div" class="text light"></i18n-t></template>
      </div>
      <div v-for="member in data" :key="`result-3-${member.name}`" class="individual-results__result-row">
        <div :class="isFilled(member, multiColor ? 'Flexible' : 'Stress-management-low') ? 'filled' : ''"></div>
        <div :class="isFilled(member, multiColor ? 'Structured' : 'Stress-management-high') ? 'filled' : ''"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: '',
    isSpread: false,
    multiColor: false,
    data: []
  },
  methods: {
    isFilled(member, attribute) {
      if (this.isSpread) {
        return member.spread.find(item => item.attribute === attribute)
      }
      return member.characteristic.find(item => item.attribute === attribute)
    }
  }
}
</script>

<style scoped lang="scss">
.individual-results {
  display: flex;

  &__members {
    display: flex;
    flex-direction: column;

    & > div {
      display: flex;
      align-items: center;
      height: 16px;
      white-space: nowrap;

      &:first-child {
        height: 30px;
        font-weight: 700;
      }
    }
  }

  &__result {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    &.result-1 {
      border: 1px solid #8c8c8c;
      .multicolor & {
        border: 1px solid #0069b4;
      }
    }

    &.result-2 {
      border: 1px solid #8c8c8c;
      .multicolor & {
        border: 1px solid #7761a7;
      }
    }

    &.result-3 {
      border: 1px solid #8c8c8c;
      .multicolor & {
        border: 1px solid #4fa8b1;
      }
    }

    &-row {
      display: flex;
      width: 120px;
      text-align: center;
      border-top: 1px solid #8c8c8c;

      .result-1 & {
        .multicolor & {
          border-top: 1px solid #0069b4;
        }
        &.head-row {
          background-color: #8c8c8c;
          border-top: none;
          .multicolor & {
            background-color: #0069b4;
          }
        }
      }

      .result-2 & {
        .multicolor & {
          border-top: 1px solid #7761a7;
        }
        &.head-row {
          background-color: #8c8c8c;
          border-top: none;
          .multicolor & {
            background-color: #7761a7;
          }
        }
      }

      .result-3 & {
        .multicolor & {
          border-top: 1px solid #4fa8b1;
        }
        &.head-row {
          background-color: #8c8c8c;
          border-top: none;
          .multicolor & {
            background-color: #4fa8b1;
          }
        }
      }

      & > div {
        height: 15px;
        width: 50%;

        .result-1 & {
          &.filled {
            background-color: #c6c6c6;
            .multicolor & {
              background-color: #80b4da;
            }
          }
        }

        .result-2 & {
          &.filled {
            background-color: #c6c6c6;
            .multicolor & {
              background-color: #bbb0d3;
            }
          }
        }

        .result-3 & {
          &.filled {
            background-color: #c6c6c6;
            .multicolor & {
              background-color: #a7d3d8;
            }
          }
        }

        &:only-child {
          width: 100%;
        }
      }
    }
  }
}
.text {
  font-size: 10px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
  color: #000000;
  &.light {
    color: #ffffff;
  }
  &.visible-overflow {
    overflow: visible;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    word-break: break-word;
  }
}
</style>
